<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-积分设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--积分设置-->
      <div class="common-form">积分设置</div>
      <el-form-item label="缴费赠送">
        <el-input placeholder="请输入缴费金额" type="number" v-model="form.money" class="max-w460">
          <template slot="prepend">缴纳</template>
          <template slot="append">元</template>
        </el-input>
        <el-input placeholder="请输入赠送积分" type="number" v-model="form.num" class="max-w460">
          <template slot="prepend">赠送</template>
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>

      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
import SettingApi from '@/api/setting.js'
export default {
 
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        num: '',
        money: '',
      }
    }
  },
  created() {
    this.getParams()
  },

  methods: {
  
    /*获取配置数据*/
    getParams() {
      let self = this
      SettingApi.pointsDetail({}, true).then(res => {
        if (res.code) {
          self.form.checkedCities = res.data.vars.values.delivery_type
          let vars = res.data.vars.values
          self.form = _.merge(self.form, res.data.vars.values)

          // self.type = vars.delivery_type
          // self.all_type = res.data.all_type
          // self.w7 = res.data.w7
          self.loading = false
        } else {
          self.$message.error('错了哦，这是一条错误消息')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    /*提交*/
    onSubmit() {
      let self = this
      // 直接进行表单验证
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          // 直接将 this.form 作为参数传递
          SettingApi.editPoints(self.form, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你，设置成功',
                type: 'success',
              })
              self.$router.push('/setting/points/index')
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    }
  
  },

}
</script>

<style scoped lang="scss">
.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/points/index.vue